// Libs
import sptk from '../../libs/sptk';

// Classes
import Expand from '../classes/Expand';

class ExpandsModule {
    constructor() {
        // ES6 Rebind
        this.onResize = this.onResize.bind(this);
        this.onCarouselReady = this.onCarouselReady.bind(this);

        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();

        this.expands = [];

        this.initExpands();

        this.checkURL();
    }

    bindUI() {
        this.ui = {};

        this.ui.expands = document.querySelectorAll('.js-expand');
    }

    bindEvents() {
        sptk.utils.$win.addEventListener('resize', this.onResize);
        sptk.utils.$body.addEventListener('carousel:rdy', this.onCarouselReady);
    }

    unbindEvents() {
        sptk.utils.$win.removeEventListener('resize', this.onResize);
        sptk.utils.$body.removeEventListener('carousel:rdy', this.onCarouselReady);
    }

    onCarouselReady() {
        this.expands.forEach((expand, index) => {
            expand.item.update();
        });
    }

    onResize() {
        this.expands.forEach((expand, index) => {
            expand.item.update();
        });
    }

    destroy() {
        this.unbindEvents();

        this.expands.forEach((expand, index) => {
            expand.item.destroy();
        });
    }

    initExpands() {
        Array.from(this.ui.expands).forEach((expand, index) => {
            const scrollTo = expand.getAttribute('data-scroll-to') ? true : false;

            this.expands.push({
                item: new Expand({
                        namespace: '',
                        el: expand,
                        scrollTo: scrollTo,
                        closeOthers: true,
                        index
                    }),
                slug: expand.getAttribute('data-slug')
            });
        });
    }

    checkURL() {
        let hash = window.location.hash.replace('#', '');

        if (hash.length === 0) {
            window.location.hash = '';
            return;
        }

        const foundTarget = this.expands.filter((expand) => { return expand.slug === hash })[0];

        if (foundTarget) {
            sptk.utils.goTo(foundTarget.item.sizes.offsetTop - 100);

            setTimeout(() => {
                foundTarget.item.open();
            }, 250);

            window.location.hash = '';
        }
    }
}

export default ExpandsModule;
